import { ProCard } from '@ant-design/pro-components';
import { CardTitleWithIcon } from '@ohpen/enso-ui';
import { CrudFormCardProps } from '../interfaces';

export const CrudFormCard = ({ children, icon, title, extra, bodyScroll }: CrudFormCardProps) => {
  return (
    <ProCard
      key="firm-card"
      title={<CardTitleWithIcon icon={icon} title={title} />}
      bordered
      headerBordered
      size="small"
      extra={extra}
      className={bodyScroll ? 'enso-ui-card-body-scroll' : undefined}
    >
      {children}
    </ProCard>
  );
};
